var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaHideIconType34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 136C108.689 136 136 108.689 136 75C136 41.3106 108.689 14 75 14C41.3106 14 14 41.3106 14 75C14 108.689 41.3106 136 75 136Z",
    stroke: "white",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.48 87.4773C102.893 87.4773 99.1221 84.1601 99.1221 78.5384C99.1221 72.7769 103.277 69.5295 108.34 69.5295C113.508 69.5295 117 72.8467 117 78.0495C117 78.7129 116.93 79.6557 116.895 79.9002H104.779C105.023 82.0301 106.804 83.357 109.039 83.357C110.854 83.357 112.635 82.7983 114.207 81.681L116.406 84.7537C114.695 86.2552 112.216 87.4773 108.48 87.4773ZM111.727 76.6528C111.693 75.1164 110.575 73.3356 108.305 73.3356C106.001 73.3356 104.884 75.0466 104.779 76.6528H111.727Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6399 87.0932V69.9136H85.0871V72.5325C86.2394 70.4723 88.0551 69.5295 90.4994 69.5295C95.0736 69.5295 96.5052 72.7769 96.5052 76.9321V87.0932H90.9184V78.0495C90.9184 75.7798 90.5692 74.0689 88.2646 74.0689C86.0648 74.0689 85.2268 76.0243 85.2268 78.5034V87.0932H79.6399Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3942 87.4773C61.9819 87.4773 57.8616 84.0903 57.8616 78.5384C57.8616 72.9515 61.9819 69.5295 67.3942 69.5295C72.8413 69.5295 76.9267 72.9515 76.9267 78.5384C76.9267 84.0903 72.8413 87.4773 67.3942 87.4773ZM67.3942 82.938C69.8035 82.938 71.27 81.0524 71.27 78.4685C71.27 75.9195 69.8035 74.0689 67.3942 74.0689C64.9499 74.0689 63.5183 75.9195 63.5183 78.4685C63.5183 81.0524 64.9499 82.938 67.3942 82.938Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 87.0933V63H39.0408L49.3765 79.2019C49.3416 78.9226 49.2717 76.3037 49.2717 74.8372V63H54.7888V87.0933H48.9924L38.4123 70.7518C38.4472 71.0311 38.517 73.9293 38.517 75.3959V87.0933H33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaHideIconType34);
export default __webpack_public_path__ + "static/media/aioa-hide-icon-type-34.2ef53c232ae5e942576717e1890122db.svg";
export { ForwardRef as ReactComponent };